import { type WheelSector } from '@/shared/ui/wheel_new/types';

export enum WHEEL_PRIZES {
  TICKET = 'TICKET',
  PREMIUM = 'PREMIUM',
  TON = 'TON',
  PLAYCOIN = 'PLAYCOIN',
  PARTNER = 'PARTNER',
  NOT = 'NOT',
  LOOTBOX = 'LOOTBOX',
  BOOSTER_PLAYCOIN = 'BOOSTER_PLAYCOIN',
  BOOSTER_XP = 'BOOSTER_XP',
  CLICKER_PLAYCOIN = 'CLICKER_PLAYCOIN',
  CLICKER_XP = 'CLICKER_XP',
  XP = 'XP',
  PHYSICAL = 'PHYSICAL',
  LUCK = 'LUCK',
}

export interface Prize {
  id: number;
  name: string;
  type: WHEEL_PRIZES;
  amount: number;
  duration?: '90d' | '365d' | string | null;
  durationSeconds: number | null;
  partSize: number;
  image: string;
  targetPartsCount?: number;
  collectedPartsCount?: number;
  isLastPart?: boolean;
  partnerUrl?: string | null;
  winReturnUrl?: string | null;
  partner: null | string;

  prizeId: number;
  boosterValue?: number;

  promoCode?: string | null;

  isSuperPrize?: boolean;
}

export enum WheelMode {
  SPIN = 'SPIN',
  SPIN_10 = 'SPIN_10',
}

export interface WheelActions {
  hydrate: (fresh: Partial<WheelStore>) => void;

  spin: (mode: WheelMode) => Promise<Prize[] | undefined>;
  fetchWheelInitialData: () => Promise<WheelSector<WHEEL_PRIZES>[] | undefined>;

  setIsActiveAd: (isActiveAd: boolean) => void;

  incrementAdsCounter: () => void;
  setAdsCounter: (newAdsCounter: number) => void;

  fetchTopEarners: () => Promise<NotEarner[]>;
}

export interface WheelStore {
  spinning: boolean;
  prizes: Prize[] | undefined;
  sectors: WheelSector<Prize['type']>[] | undefined;
  showReward: boolean;
  actions: WheelActions;
  isCompletedPoll: boolean;
  doublePrizeTaskUrl: string | null | undefined;
  isActiveAd: boolean;

  adsCounter: number;
  canWatchAd: boolean;

  topEarners: NotEarner[] | undefined;
}

export interface SpinResponse {
  prizes: Prize[];
  doublePrizeTaskUrl: string | null;
}

export interface NotEarner {
  telegramId: number;
  totalAmount: number;
  icon: string;
  name: string;
  username: string;
}
